import { height, width } from './general';
import { CareItem, DuoItem } from 'src/replicant/buruburu/care/care.ruleset';
import popups from './popups';
import buttons from './buttons';
import { assertNever } from 'src/replicant/utils';
import { degreesToRadians } from 'src/replicant/utils/convert';
import { TutorialStep } from 'src/replicant/buruburu/tutorial/tutorial.ruleset';
import { Locale } from 'src/replicant/ruleset/locale';
import { ImageScaleViewOpts } from '@play-co/timestep-core/lib/ui/ImageScaleView';
import { PetSpecies } from 'src/replicant/buruburu/pet';
import { FlexBoxImageScaleViewOpts } from '@play-co/timestep-core/flexbox';

const careItemIcons: Record<CareItem['id'], string> =
  // prettier-ignore
  {
    // ---------------------
    // Toys
    // ---------------------
    t_commonBell_b: 'assets/ui/buruburu/care/care_item_toy_CommonBell.png',
    t_commonBell_k: 'assets/ui/buruburu/care/care_item_toy_CommonBell.png',
    t_commonBell_y: 'assets/ui/buruburu/care/care_item_toy_CommonBell.png',
    t_commonBell_a: 'assets/ui/buruburu/care/care_item_toy_CommonBell.png',

    t_miracleBall_b: 'assets/ui/buruburu/care/care_item_toy_MiracleBall.png',
    t_miracleBall_k: 'assets/ui/buruburu/care/care_item_toy_MiracleBall.png',
    t_miracleBall_y: 'assets/ui/buruburu/care/care_item_toy_MiracleBall.png',
    t_miracleBall_a: 'assets/ui/buruburu/care/care_item_toy_MiracleBall.png',

    t_woollyCaterpillar_k: 'assets/ui/buruburu/care/care_item_toy_WoollyCaterpillar.png',
    t_woollyCaterpillar_y: 'assets/ui/buruburu/care/care_item_toy_WoollyCaterpillar.png',
    t_woollyCaterpillar_a: 'assets/ui/buruburu/care/care_item_toy_WoollyCaterpillar.png',

    t_noSurpriseJackInTheBox_k: 'assets/ui/buruburu/care/care_item_toy_JackintheBox.png',
    t_noSurpriseJackInTheBox_y: 'assets/ui/buruburu/care/care_item_toy_JackintheBox.png',
    t_noSurpriseJackInTheBox_a: 'assets/ui/buruburu/care/care_item_toy_JackintheBox.png',

    t_fairytaleUnicorn_y: 'assets/ui/buruburu/care/care_item_toy_Unicorn.png',
    t_fairytaleUnicorn_a: 'assets/ui/buruburu/care/care_item_toy_Unicorn.png',

    t_autoPilotAirplane_y: 'assets/ui/buruburu/care/care_item_toy_PiilotAirplane.png',
    t_autoPilotAirplane_a: 'assets/ui/buruburu/care/care_item_toy_PiilotAirplane.png',

    t_emptyMagicLamp_a: 'assets/ui/buruburu/care/care_item_toy_MagicLamp.png',

    t_doremiPiano_a: 'assets/ui/buruburu/care/care_item_toy_piano.png',

    // ---------------------
    // Food
    // ---------------------

    f_buruburuFood_b: 'assets/ui/buruburu/care/care_item_food_Buruburu.png',
    f_buruburuFood_k: 'assets/ui/buruburu/care/care_item_food_Buruburu.png',
    f_buruburuFood_y: 'assets/ui/buruburu/care/care_item_food_Buruburu.png',
    f_buruburuFood_a: 'assets/ui/buruburu/care/care_item_food_Buruburu.png',

    f_gentleSushi_b: 'assets/ui/buruburu/care/care_item_food_Sushi.png',
    f_gentleSushi_k: 'assets/ui/buruburu/care/care_item_food_Sushi.png',
    f_gentleSushi_y: 'assets/ui/buruburu/care/care_item_food_Sushi.png',
    f_gentleSushi_a: 'assets/ui/buruburu/care/care_item_food_Sushi.png',

    f_skewedSalad_k: 'assets/ui/buruburu/care/care_item_food_Salad.png',
    f_skewedSalad_y: 'assets/ui/buruburu/care/care_item_food_Salad.png',
    f_skewedSalad_a: 'assets/ui/buruburu/care/care_item_food_Salad.png',

    f_attractiveCurryAndRice_k: 'assets/ui/buruburu/care/care_item_food_Curry&Rice.png',
    f_attractiveCurryAndRice_y: 'assets/ui/buruburu/care/care_item_food_Curry&Rice.png',
    f_attractiveCurryAndRice_a: 'assets/ui/buruburu/care/care_item_food_Curry&Rice.png',

    f_tooSpicyTteokbokki_y: 'assets/ui/buruburu/care/care_item_food_Tteokbokki.png',
    f_tooSpicyTteokbokki_a: 'assets/ui/buruburu/care/care_item_food_Tteokbokki.png',

    f_meatLessBurger_y: 'assets/ui/buruburu/care/care_item_food_MeatLessBurger.png',
    f_meatLessBurger_a: 'assets/ui/buruburu/care/care_item_food_MeatLessBurger.png',

    f_dimsumTower_a: 'assets/ui/buruburu/care/care_item_food_DimSumTower.png',

    f_edibleIsland_a: 'assets/ui/buruburu/care/care_item_food_EdibleIsland.png',

    // ---------------------
    // Snack
    // ---------------------

    s_rainbowCottonCandy_b: 'assets/ui/buruburu/care/care_item_snack_RainbowCottonCandy.png',
    s_rainbowCottonCandy_k: 'assets/ui/buruburu/care/care_item_snack_RainbowCottonCandy.png',
    s_rainbowCottonCandy_y: 'assets/ui/buruburu/care/care_item_snack_RainbowCottonCandy.png',
    s_rainbowCottonCandy_a: 'assets/ui/buruburu/care/care_item_snack_RainbowCottonCandy.png',

    s_candiesFromPocket_b: 'assets/ui/buruburu/care/care_item_snack_CandiesfromPocket.png',
    s_candiesFromPocket_k: 'assets/ui/buruburu/care/care_item_snack_CandiesfromPocket.png',
    s_candiesFromPocket_y: 'assets/ui/buruburu/care/care_item_snack_CandiesfromPocket.png',
    s_candiesFromPocket_a: 'assets/ui/buruburu/care/care_item_snack_CandiesfromPocket.png',

    s_tooHardRiceCracker_k: 'assets/ui/buruburu/care/care_item_snack_TooHardRiceCracker.png',
    s_tooHardRiceCracker_y: 'assets/ui/buruburu/care/care_item_snack_TooHardRiceCracker.png',
    s_tooHardRiceCracker_a: 'assets/ui/buruburu/care/care_item_snack_TooHardRiceCracker.png',

    s_dreamingBerryParfait_k: 'assets/ui/buruburu/care/care_item_snack_DreamingBerryParfait.png',
    s_dreamingBerryParfait_y: 'assets/ui/buruburu/care/care_item_snack_DreamingBerryParfait.png',
    s_dreamingBerryParfait_a: 'assets/ui/buruburu/care/care_item_snack_DreamingBerryParfait.png',

    s_expensiveFruits_y: 'assets/ui/buruburu/care/care_item_snack_ExpensiveFruits.png',
    s_expensiveFruits_a: 'assets/ui/buruburu/care/care_item_snack_ExpensiveFruits.png',

    s_wishFulfillingMontBlanc_y: 'assets/ui/buruburu/care/care_item_snack_Wishfulfilling_MontBlanc.png',
    s_wishFulfillingMontBlanc_a: 'assets/ui/buruburu/care/care_item_snack_Wishfulfilling_MontBlanc.png',

    s_mameDaifuku_a: 'assets/ui/buruburu/care/care_item_snack_MameDaifuku.png',

    s_bucketPudding_a: 'assets/ui/buruburu/care/care_item_snack_BucketPudding.png',

    // ---------------------
    // Medicine
    // ---------------------

    fa_capsule: 'assets/ui/buruburu/care/care_item_firstaid_Capsule.png',
    fa_whiteTooth: 'assets/ui/buruburu/care/care_item_firstaid_WhiteTooth.png',
    fa_superCapsule: 'assets/ui/buruburu/care/care_item_firstaid_SuperCapsule.png',
    fa_shiningCapsule: 'assets/ui/buruburu/care/care_item_firstaid_ShiningTooth.png',

    fa_perfume: 'assets/ui/buruburu/care/care_item_firstaid_PanaceaColon.png',
    fa_superPerfume: 'assets/ui/buruburu/care/care_item_firstaid_GoldPanacea.png',

    // ---------------------
    // Invitation
    // ---------------------

    i_vowsCoffee: 'assets/ui/buruburu/care/care_item_invitation_coffe.png',
    i_ultimateVowsCoffee: 'assets/ui/buruburu/care/care_item_invitation_ultimate_coffe.png',
  };

export function getCareItemAnimationName<T extends CareItem['id']>(
  careItemId: T,
) {
  switch (careItemId) {
    case 'f_gentleSushi_b':
    case 'f_gentleSushi_k':
    case 'f_gentleSushi_y':
    case 'f_gentleSushi_a':
      return 'gentleSushi';

    case 'f_buruburuFood_b':
    case 'f_buruburuFood_k':
    case 'f_buruburuFood_y':
    case 'f_buruburuFood_a':
      return 'buruburuFood';

    case 'f_attractiveCurryAndRice_k':
    case 'f_attractiveCurryAndRice_y':
    case 'f_attractiveCurryAndRice_a':
      return 'attractiveCurryAndRice';

    case 'f_skewedSalad_k':
    case 'f_skewedSalad_y':
    case 'f_skewedSalad_a':
      return 'skewedSalad';

    case 'f_meatLessBurger_y':
    case 'f_meatLessBurger_a':
      return 'meatLessBurger';

    case 'f_tooSpicyTteokbokki_y':
    case 'f_tooSpicyTteokbokki_a':
      return 'tooSpicyTteokbokki';

    case 'f_edibleIsland_a':
      return 'edibleIsland';

    case 'f_dimsumTower_a':
      return 'dimsumTower';

    case 's_candiesFromPocket_b':
    case 's_candiesFromPocket_k':
    case 's_candiesFromPocket_y':
    case 's_candiesFromPocket_a':
      return 'candiesFromPocket';

    case 's_rainbowCottonCandy_b':
    case 's_rainbowCottonCandy_k':
    case 's_rainbowCottonCandy_y':
    case 's_rainbowCottonCandy_a':
      return 'rainbowCottonCandy';

    case 's_dreamingBerryParfait_k':
    case 's_dreamingBerryParfait_y':
    case 's_dreamingBerryParfait_a':
      return 'dreamingBerryParfait';

    case 's_tooHardRiceCracker_k':
    case 's_tooHardRiceCracker_y':
    case 's_tooHardRiceCracker_a':
      return 'tooHardRiceCracker';

    case 's_expensiveFruits_y':
    case 's_expensiveFruits_a':
      return 'expensiveFruits';

    case 's_wishFulfillingMontBlanc_y':
    case 's_wishFulfillingMontBlanc_a':
      return 'wishFulfillingMontBlanc';

    case 's_bucketPudding_a':
      return 'bucketPudding';

    case 's_mameDaifuku_a':
      return 'mameDaifuku';

    case 't_commonBell_b':
    case 't_commonBell_k':
    case 't_commonBell_y':
    case 't_commonBell_a':
      return 'commonBell';

    case 't_miracleBall_b':
    case 't_miracleBall_k':
    case 't_miracleBall_y':
    case 't_miracleBall_a':
      return 'miracleBall';

    case 't_woollyCaterpillar_k':
    case 't_woollyCaterpillar_y':
    case 't_woollyCaterpillar_a':
      return 'woollyCaterpillar';

    case 't_noSurpriseJackInTheBox_k':
    case 't_noSurpriseJackInTheBox_y':
    case 't_noSurpriseJackInTheBox_a':
      return 'noSurpriseJackInTheBox';

    case 't_autoPilotAirplane_y':
    case 't_autoPilotAirplane_a':
      return 'autoPilotAirplane';

    case 't_fairytaleUnicorn_y':
    case 't_fairytaleUnicorn_a':
      return 'fairytaleUnicorn';

    case 't_emptyMagicLamp_a':
      return 'emptyMagicLamp';

    case 't_doremiPiano_a':
      return 'piano';

    case 'fa_capsule':
      return 'capsule';

    case 'fa_superCapsule':
      return 'superCapsule';

    case 'fa_whiteTooth':
      return 'whiteTooth';

    case 'fa_shiningCapsule':
      return 'shiningTooth';

    case 'fa_perfume':
      return 'panaceaColon';

    case 'fa_superPerfume':
      return 'goldPanaceaColon';

    case 'i_vowsCoffee':
      return 'acceptance_coffee';

    case 'i_ultimateVowsCoffee':
      return 'acceptance_ultimateCoffee';

    default:
      assertNever(careItemId);
  }
}

export function getDuoItemAnimationName<
  T extends Extract<CareItem['id'], DuoItem>
>(careItemId: T, species: PetSpecies) {
  switch (careItemId) {
    case 'i_vowsCoffee':
      return `${species}_invite_normalCoffee`;

    case 'i_ultimateVowsCoffee':
      return `${species}_invite_ultimateCoffee`;

    default:
      assertNever(careItemId);
  }
}

namespace confirmCareItem {
  const popup = {
    zIndex: 10000,
    width: popups.buruburu.width,
    height: 594,
    darkerBg: false,
  };

  const message = {
    height: 50,
    x: 40,
    y: 80,
    zIndex: 1,
  };

  const underline = <const>{
    ...popups.underline,
    x: message.x,
  };

  const careItemPanel = <const>{
    image: 'assets/ui/buruburu/care/care_item_description_panel.png',
    height: 182,
    width: 491,
    x: (popup.width - 491) / 2,
    y: 150,
  };

  const currency = <const>{
    scaleMethod: 'contain',
    image: 'assets/ui/hud/icons/hud_coin.png',
    y: -4,
    width: 58,
    height: 58,
  };

  const highlightRow = <const>{
    x: 40,
    width: popup.width - 80,
    height: 50,
    image: 'assets/ui/popups/panel_highlight.png',
    slices: {
      top: 9,
      bot: 9,
      left: 9,
      right: 9,
    },
  };
  const highlightRowLabel = <const>{
    x: 10,
    size: 22,
    font: 'Body',
    color: '#BF8147',
    height: highlightRow.height,
    width: 300,
    verticalAlign: 'center',
  };
  const highlightRowValue = <const>{
    size: 22,
    font: 'Body',
    color: '#9A7171',
    height: 50,
    width: 130,
    x: highlightRow.width - 130 - currency.width - 10,
    verticalAlign: 'center',
    align: 'right',
  };

  const costRow = {
    ...highlightRow,
    y: 350,
  };

  const balanceRow = {
    ...highlightRow,
    y: 418,
  };

  const commandButton = <const>{
    fontSize: 40,
    labelOffsetY: -2,
    font: 'Body',
    y: 594 - 15 - 90,
    width: 235,
    height: 90,
  };
  const backButton = {
    ...buttons.cancel,
    ...commandButton,
    x: 40,
  };
  const okButton = {
    ...buttons.secondary,
    ...commandButton,
    x: 304,
  };

  export const ui = {
    popup,
    message,
    underline,
    careItemPanel,
    careItemIcons,
    costRow,
    balanceRow,
    highlightRowLabel,
    highlightRowValue,
    currency,
    backButton,
    okButton,
  };
}

namespace bedroom {
  const bedroom = {
    image: 'assets/ui/buruburu/bedroom.png',
  };
  const bedroomBed = {
    image: 'assets/ui/buruburu/bedroom_bed.png',
    width: 490,
    height: 319,
    centerOnOrigin: true,
    x: width / 2,
    y: 840,
  };
  const bedroomOverlay = {
    backgroundColor: 'rgba(0,0,0,0.67)',
    opacity: 0,
    zIndex: height,
  };
  const bedroomSign = {
    image: 'assets/ui/buruburu/bedroom_sleeping-sign.png',
    width: 261,
    height: 240,
    x: 25,
    y: 265,
    zIndex: 2,
  };
  const bedroomSignTextHeight = 85;
  const bedroomSignText = <const>{
    font: 'Body',
    align: 'center',
    size: 32,
    color: '#CD5028',
    width: 204,
    height: bedroomSignTextHeight,
    centerOnOrigin: true,
    x: bedroomSign.width / 2 - 6,
    y: bedroomSign.height - bedroomSignTextHeight,
  };

  export const ui = {
    bedroom,
    bedroomBed,
    bedroomOverlay,
    bedroomSign,
    bedroomSignText,
  };
}

namespace minigame {
  const scene = {
    image: 'assets/ui/buruburu/minigame.png',
  };

  namespace match3 {
    export const board: ImageScaleViewOpts = {
      width: 720,
      height: 594,
    };
    board.x = (width - board.width) / 2;
  }

  const comboMessage = {
    x: width / 2,
    y: height * 0.4,
    align: 'center' as const,
    verticalAlign: 'center' as const,
    color: 'white',
    wordWrap: false,
    font: 'Title',
    width: 410,
    height: 40,
    centerOnOrigin: true,
    centerAnchor: true,
    visible: false,
    zIndex: 3,
    r: degreesToRadians(-13),
    size: 72,
  } as const;

  const pointsMessage = {
    ...comboMessage,
    color: '#F19A84',
    y: comboMessage.y + 40,
  };

  export const style = {
    scene,
    match3,
    comboMessage,
    pointsMessage,
  };
}

namespace menu {
  const menu = <const>{
    width,
    height: 586,
    infinite: true,
    image: 'assets/ui/buruburu/popup_overlay.png',
    flex: {
      position: 'absolute',
      left: 0,
      // top: '-455px',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-end',
      paddingBottom: 170,
    },
  };
  const menuRow = <const>{
    width: width * 0.75,
    flex: {
      marginTop: 6,
      justifyContent: 'space-evenly',
    },
    canHandleEvents: false,
  };
  const closeHintBg = {
    image: 'assets/ui/buruburu/menu/menu_taptoclose.png',
    autoSize: true,
  };
  const closeHintText = <const>{
    color: '#FDFFEE',
    font: 'Body',
    size: 22,
    align: 'center',
    verticalAlign: 'center',
  };
  const menuButton = <const>{
    image: 'assets/ui/buruburu/menu/menu_item_bg.png',
    scaleMethod: '9slice',
    sourceSlices: {
      horizontal: { left: 13, right: 13 },
      vertical: { top: 13, bottom: 26 },
    },
    font: 'Body',
    align: 'center',
    fontSize: 22,
    textColor: '#C57C58',
    labelHeight: 28,
    labelPaddingX: 20,
    width: 150,
    height: 169,
    labelOffsetX: -3,
    labelOffsetY: 107,
  };

  const icons = {
    encyclopedia: {
      image: `assets/ui/buruburu/menu/menu_action_encyclopedia.png`,
      height: 71,
      width: 102,
      offset: { x: 0, y: -27 },
    },
    familyTree: {
      image: `assets/ui/buruburu/menu/menu_action_familytree.png`,
      height: 71,
      width: 102,
      offset: { x: 0, y: -27 },
    },
    mission: {
      image: `assets/ui/buruburu/menu/menu_action_mission.png`,
      height: 71,
      width: 102,
      offset: { x: 0, y: -27 },
    },
    decor: {
      image: `assets/ui/buruburu/menu/menu_action_decor.png`,
      height: 71,
      width: 102,
      offset: { x: 0, y: -27 },
    },
    profile: {
      image: `assets/ui/buruburu/menu/menu_action_profile.png`,
      height: 71,
      width: 102,
      offset: { x: 0, y: -27 },
    },
    settings: {
      image: `assets/ui/buruburu/menu/menu_action_settings.png`,
      height: 71,
      width: 102,
      offset: { x: 0, y: -27 },
    },
    coins: {
      image: `assets/ui/buruburu/menu/menu_shop_coin_icon.png`,
      height: 58,
      width: 58,
      offset: { x: 0, y: -27 },
    },
    energy: {
      image: `assets/ui/buruburu/menu/menu_shop_energy_icon.png`,
      height: 61,
      width: 62,
      offset: { x: 0, y: -27 },
    },
    gems: {
      image: `assets/ui/buruburu/menu/menu_shop_diamond_icon.png`,
      height: 83,
      width: 73,
      offset: { x: 0, y: -27 },
    },
  };

  export const ui = {
    menu: menu,
    menuRow,
    menuButton,
    closeHintBg,
    closeHintText,
    icons,
  };
}

namespace tutorial {
  const frame = <const>{
    image: 'assets/ui/tutorial/tutorial_popup_frame_half.png',
    width: 323,
    height: 1202,
    scaleMethod: '3slice',
    sourceSlices: {
      vertical: { top: 112, bottom: 210 },
    },
  };

  const popup = {
    zIndex: 10000,
    width: frame.width * 2,
    height: frame.height,
    darkerBg: false,
    skipTitle: true,
    boxOpts: {
      image: null,
    },
  };

  const message = {
    color: '#3C73A3',
    size: 42,
    height: 56,
    x: 90,
    y: 18,
    zIndex: 1,
  };

  const pageIndicator = <const>{
    size: 24,
    font: 'Body',
    color: message.color,
    height: 48,
    width: 48,
    verticalAlign: 'center',
    align: 'center',
    centerOnOrigin: true,
    x: 320,
    y: 1040,
  };

  const navButton = <const>{
    y: 1012,
    width: 90,
    height: 68,
  };
  const prevButton = {
    ...buttons.navPrevious,
    ...navButton,
    x: 72,
  };
  const nextButton = {
    ...buttons.navNext,
    ...navButton,
    x: 480,
  };
  const closeButton = <const>{
    fontSize: 42,
    labelOffsetX: -4,
    labelOffsetY: -2,
    font: 'Body',
    ...buttons.secondary,
    disabledFontOffsetY: 0,
    width: 230,
    height: 89,
    x: popup.width / 2,
    y: 1120,
    centerOnOrigin: true,
  };

  export const images: Record<TutorialStep, Record<Locale, string[]>> = {
    basicGameplay: {
      en: ['assets/tutorial/Tut1_EN.jpg', 'assets/tutorial/Tut2_EN.jpg'],
    },
    chatWithPets: {
      en: ['assets/tutorial/Tut3_EN.jpg', 'assets/tutorial/Tut4_EN.jpg'],
    },
    careForPets: {
      en: ['assets/tutorial/Tut5_EN.jpg', 'assets/tutorial/Tut6_EN.jpg'],
    },
    petsGetSick: {
      en: ['assets/tutorial/Tut7_EN.jpg', 'assets/tutorial/Tut8_EN.jpg'],
    },
    friendReferral: {
      en: ['assets/tutorial/Tut10_EN.jpg'],
    },
    profile: {
      en: ['assets/tutorial/Tut11_EN.jpg', 'assets/tutorial/Tut12_EN.jpg'],
    },
    match3: {
      en: ['assets/tutorial/Tut9_EN.jpg'],
    },
    adult: {
      en: ['assets/tutorial/Tut13_EN.jpg'],
    },
    visitFriend: {
      en: ['assets/tutorial/Tut14_EN.jpg'],
    },
    duoInvite: {
      en: ['assets/tutorial/Tut15_EN.jpg'],
    },
    duoInviteReceived: {
      en: ['assets/tutorial/Tut16_EN.jpg'],
    },
  };

  export const ui = {
    popup,
    frame,
    message,
    pageIndicator,
    prevButton,
    nextButton,
    closeButton,
    images,
  };
}

namespace social {
  export namespace invite {
    const popup = {
      zIndex: 10000,
      width: popups.buruburu.width,
      height: 700,
      darkerBg: false,
    };

    namespace friendTile {
      export const container: FlexBoxImageScaleViewOpts = {
        image: 'assets/ui/shared/lossless/scroller_panel_blue.png',
        height: 114,
        scaleMethod: '9slice',
        sourceSlices: {
          vertical: {
            top: 19,
            bottom: 28,
          },
          horizontal: {
            left: 19,
            right: 22,
          },
        },
        flex: {
          flexGrow: 1,
          alignItems: 'center',
          paddingBottom: 4,
        },
      };

      export const image = <const>{
        scaleMethod: 'contain',
        width: 78,
        height: 78,
      };

      export const name = <const>{
        size: 30,
        font: 'Body',
        color: '#9A7171',
        verticalAlign: 'top',
        width: 211,
        height: 36,
        y: 18,
      };

      export const amount = <const>{
        size: 32,
        font: 'Body',
        color: '#7191AB',
        x: 48,
        y: 59,
        width: 75,
        height: 34,
        align: 'left',
      };

      export const currencyGems = <const>{
        y: 48,
        width: 48,
        height: 48,
        scaleMethod: 'contain',
        image: 'assets/ui/hud/icons/hud_gem.png',
      };

      export const currencyEnergy = <const>{
        y: 51,
        width: 39,
        height: 46,
        scaleMethod: 'contain',
        image: 'assets/ui/hud/icons/hud_energy.png',
      };

      export const cta = <const>{
        ...buttons.secondary,
        font: 'Body',
        fontSize: 30,
        width: 130,
        height: 72,
      };
    }

    export namespace confirm {
      export const popup = {
        zIndex: 10000,
        width: popups.buruburu.width,
        height: 549,
        darkerBg: false,
      };

      export const message = {
        height: 50,
        x: 40,
        y: 80,
        zIndex: 1,
      };

      export const underline = <const>{
        height: 5,
        x: message.x,
        y: 130,
        image: 'assets/ui/popups/panel_underline.png',
        scaleMethod: '3slice',
        sourceSlices: {
          horizontal: { left: 5, right: 5 },
        },
      };

      const friendTileContainer = friendTile.container;
      export const friendPanel = {
        image: friendTileContainer.image,
        slices: {
          top: friendTileContainer.sourceSlices.vertical.top,
          bot: friendTileContainer.sourceSlices.vertical.bottom,
          left: friendTileContainer.sourceSlices.horizontal.left,
          right: friendTileContainer.sourceSlices.horizontal.right,
        },
        width: popups.buruburu.width - 100,
        height: 172,
        x: 50,
        y: 166,
      };

      export const icon = <const>{
        scaleMethod: 'contain',
        x: 20,
        y: 20,
        width: 124,
        height: 124,
      };

      export const name = <const>{
        font: 'Body',
        color: '#9A7171',
        y: 64,
        size: 32,
        x: 165,
        height: 39,
        width: 283,
        verticalAlign: 'bottom',
      };

      export const notice = <const>{
        ...message,
        font: 'Body',
        color: '#BF8147',
        size: 24,
        align: 'center',
        y: 372,
      };

      const commandButton = {
        y: 429,
      };
      export const okButton = {
        ...confirmCareItem.ui.okButton,
        ...commandButton,
      };
      export const cancelButton = {
        ...confirmCareItem.ui.backButton,
        ...commandButton,
      };
    }

    export const ui = {
      popup,
      friendTile,
      confirm,
    };
  }
}

namespace profile {
  export namespace edit {
    export const noticeText = {
      color: '#dab07e',
      size: 18,
      align: 'justify',
      centerOnOrigin: true,
      font: 'Body',
      height: 130,
      canHandleEvents: true,
    } as const;

    export const input = {
      height: 61,
      centerOnOrigin: true,
      inputStyle: {
        background: '#fcf0d3',
        borderRadius: '10px',
        color: '#b68351',
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: '10vm',
      },
    };

    export const avatarSize = 140;
    export const avatarOutlineSize = 8;

    export const avatarButton = {
      width: avatarSize - avatarOutlineSize,
      height: avatarSize - avatarOutlineSize,
      x: avatarOutlineSize / 2,
      y: avatarOutlineSize / 2,
    };

    export const avatarOutline = {
      width: avatarSize,
      height: avatarSize,
    };
  }

  export namespace profile {
    export const contentPanel = {
      image: 'assets/ui/shared/lossless/panel_overlay.png',
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 20, right: 20 },
        vertical: { top: 27, bottom: 27 },
      },
      height: 47,
      centerOnOrigin: true,
    } as const;

    export const frameMargin = 20;

    export const titleText = {
      color: '#b48454',
      size: 25,
      align: 'left',
      verticalAlign: 'center',
      centerOnOrigin: true,
      font: 'Body',
    } as const;

    export const dataText = {
      color: '#947372',
      size: 25,
      align: 'right',
      verticalAlign: 'center',
      centerOnOrigin: true,
      font: 'Body',
    } as const;
  }

  const button = {
    labelOffsetY: -1,
    fontSize: 46,
    width: 240,
    height: 100,
    centerOnOrigin: true,
    font: 'Body',
  } as const;

  export const ui = {
    profile,
    edit,
    button,
  };
}

export default {
  backgroundDefaults: {
    width,
    height,
    horizontalAlign: 'center',
    verticalAlign: 'center',
  },

  debut: {
    image: 'assets/ui/buruburu/debut/debut-room.png',
  },

  livingRoom: {
    image: 'assets/ui/buruburu/living-room.png',
  },

  diningRoom: {
    image: 'assets/ui/buruburu/dining-room.png',
  },

  diningRoomMat: {
    image: 'assets/ui/buruburu/dining-room_mat.png',
    width: 529,
    height: 172,
    centerOnOrigin: true,
    x: width / 2,
    y: 934,
  },

  diningRoomMatDouble: {
    image: 'assets/ui/buruburu/dining-room_mat-double.png',
    width: 600,
    height: 194,
    centerOnOrigin: true,
    x: width / 2,
    y: 915,
  },

  bathroom: {
    image: 'assets/ui/buruburu/bathroom.png',
  },

  bathroomBathTop: {
    image: 'assets/ui/buruburu/bathroom_bath_top.png',
    width: 501,
    height: 220,
    centerOnOrigin: true,
    x: 364,
    y: 898,
  },

  bathroomBathFront: {
    image: 'assets/ui/buruburu/bathroom_bath_front.png',
    width: 501,
    height: 220,
    centerOnOrigin: true,
    x: 364,
    y: 898,
    zIndex: height,
  },

  toiletRoom: {
    image: 'assets/ui/buruburu/toilet-room.png',
  },
  toiletRoomToilet: {
    image: 'assets/ui/buruburu/toilet-room_toilet.png',
    width: 360,
    height: 573,
    centerOnOrigin: true,
    x: 367,
    y: 707,
  },

  ...bedroom.ui,

  frame: {
    autoSize: true, // 720 x variable height
    // vertical offset and anchor will be dynamically set to bottom after creation
    centerOnOrigin: true,
    centerAnchor: true,
  },

  menu: menu.ui,

  minigame: minigame.style,

  friends: {
    actionIcons: {
      invite: {
        image: `assets/ui/friends/friend_action_referral.png`,
        height: 71,
        width: 102,
        offset: { x: 0, y: -27 },
      },
      duoReceivedList: {
        image: `assets/ui/duo/icons/duo_received.png`,
        height: 71,
        width: 102,
        offset: { x: 0, y: -27 },
      },
      duoSentList: {
        image: `assets/ui/duo/icons/duo_sent.png`,
        height: 71,
        width: 102,
        offset: { x: 0, y: -27 },
      },
      gift: {
        image: `assets/ui/friends/friend_action_gift.png`,
        height: 71,
        width: 102,
        offset: { x: 0, y: -27 },
      },
      visitorList: {
        image: `assets/ui/friends/friend_action_visitorslist.png`,
        height: 71,
        width: 102,
        offset: { x: 0, y: -27 },
      },
      visitFriend: {
        image: `assets/ui/friends/friend_action_visitfriend.png`,
        height: 71,
        width: 102,
        offset: { x: 0, y: -27 },
      },
    },
  },

  care: {
    actionIcons: {
      food: {
        image: `assets/ui/buruburu/care/care_action_food.png`,
        height: 71,
        width: 102,
        offset: { x: 0, y: -27 },
      },
      snack: {
        image: `assets/ui/buruburu/care/care_action_snack.png`,
        height: 71,
        width: 102,
        offset: { x: 0, y: -27 },
      },
      toy: {
        image: `assets/ui/buruburu/care/care_action_toy.png`,
        height: 71,
        width: 102,
        offset: { x: 0, y: -27 },
      },
      firstAid: {
        image: `assets/ui/buruburu/care/care_action_firstaid.png`,
        height: 71,
        width: 102,
        offset: { x: 0, y: -27 },
      },
      bath: {
        image: `assets/ui/buruburu/care/care_action_bath.png`,
        height: 71,
        width: 102,
        offset: { x: 0, y: -27 },
      },
      toilet: {
        image: `assets/ui/buruburu/care/care_action_toilet.png`,
        height: 71,
        width: 102,
        offset: { x: 0, y: -27 },
      },
    },
    itemIcons: careItemIcons,
    itemButton: {
      container: {
        image: 'assets/ui/buruburu/care/care_item_cell.png',
        width: 238,
        height: 136,
      },
      image: {
        scaleMethod: 'contain',
        width: 84,
        height: 102,
        x: 15,
        y: 15,
      },
      name: {
        size: 20,
        font: 'Body',
        color: '#9A7171',
        verticalAlign: 'top',
        width: 106,
        height: 48,
        x: 107,
        y: 25,
      },
      price: {
        size: 20,
        font: 'Body',
        color: '#9A7171',
        x: 115,
        y: 92,
        width: 75,
        height: 24,
        align: 'right',
      },
      currency: {
        x: 192,
        y: 84,
        width: 38,
        height: 38,
        scaleMethod: 'contain',
        image: 'assets/ui/hud/icons/hud_coin.png',
      },
      icons: careItemIcons,
    },
    confirmation: confirmCareItem.ui,
  },

  tutorial: tutorial.ui,

  invite: social.invite.ui,
  profile: profile.ui,
} as const;
